"use strict";

var _classCallCheck = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/var/nobackup/jenkins/jobs/DDI Frontend/branches/release-2022-04.94hkrn/workspace/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Toolbar = void 0;

var Rect_1 = require("../Core/Rect");

var ToolbarIcon_1 = require("./ToolbarIcon");

var ToolbarSelectIcon_1 = require("./ToolbarSelectIcon");

var ToolbarSeparator_1 = require("./ToolbarSeparator");

var ToolbarSwitchIcon_1 = require("./ToolbarSwitchIcon");

var ToolbarTriggerIcon_1 = require("./ToolbarTriggerIcon");

var Toolbar = /*#__PURE__*/function () {
  function Toolbar(svgHost) {
    _classCallCheck(this, Toolbar);

    this.iconSpace = 8;
    this.areHotKeysEnabled = true;
    this.icons = new Array();
    this.buildUIElements(svgHost);
  }

  _createClass(Toolbar, [{
    key: "addSelector",
    value: function addSelector(icon, actor) {
      var _this = this;

      var newIcon = new ToolbarSelectIcon_1.ToolbarSelectIcon(this.paper, icon, function (action) {
        _this.select(action);

        actor(action);
      });
      this.addIcon(newIcon);
    }
  }, {
    key: "addSwitch",
    value: function addSwitch(icon, actor) {
      var newIcon = new ToolbarSwitchIcon_1.ToolbarSwitchIcon(this.paper, icon, function (action) {
        actor(action);
      });
      this.addIcon(newIcon);
    }
  }, {
    key: "addSeparator",
    value: function addSeparator() {
      var newIcon = new ToolbarSeparator_1.ToolbarSeparator(this.paper, ToolbarIcon_1.ToolbarIcon.IconWidth);
      this.addIcon(newIcon);
    }
  }, {
    key: "addTrigger",
    value: function addTrigger(icon, actor) {
      var newIcon = new ToolbarTriggerIcon_1.ToolbarTriggerIcon(this.paper, icon, function (action) {
        actor(action);
      });
      this.addIcon(newIcon);
    }
  }, {
    key: "select",
    value: function select(action) {
      this.icons.forEach(function (icon) {
        if (icon instanceof ToolbarSelectIcon_1.ToolbarSelectIcon) {
          if (icon.description.action !== action) {
            icon.unselect();
          } else {
            icon.select();
          }
        }
      });
    }
  }, {
    key: "setSwitch",
    value: function setSwitch(action, on) {
      var switchIcon = this.findIconByAction(action);

      if (switchIcon !== undefined && switchIcon instanceof ToolbarSwitchIcon_1.ToolbarSwitchIcon) {
        on ? switchIcon.select() : switchIcon.unselect();
      }
    }
  }, {
    key: "enableHotkeys",
    value: function enableHotkeys() {
      this.areHotKeysEnabled = true;
    }
  }, {
    key: "disableHotkeys",
    value: function disableHotkeys() {
      this.areHotKeysEnabled = false;
    }
  }, {
    key: "buildUIElements",
    value: function buildUIElements(svgHost) {
      this.baseParent = svgHost;
      this.paper = Snap(svgHost);
      this.paperRect = new Rect_1.Rect(svgHost.width.baseVal.value, svgHost.height.baseVal.value);
      var toolbarGroup = this.paper.g();
      toolbarGroup.addClass("toolbarLayer");
      this.recalculateToolbarSize();
      this.backgroundRect = this.paper.rect(0, 0, this.toolbarWidth, this.toolbarHeight);
      this.backgroundRect.addClass("toolbarBGStyle");
      toolbarGroup.add(this.backgroundRect);
      this.iconsLayer = this.paper.g();
      this.iconsLayer.addClass("iconsLayerStyle");
      toolbarGroup.add(this.iconsLayer);
      this.subscribeToKeyboardEvents();
    }
  }, {
    key: "recalculateToolbarSize",
    value: function recalculateToolbarSize(newIcon) {
      if (newIcon === undefined) {
        this.toolbarWidth = ToolbarIcon_1.ToolbarIcon.IconWidth + 2 * this.iconSpace;
        this.toolbarHeight = this.icons.length * (ToolbarIcon_1.ToolbarIcon.IconHeight + this.iconSpace) + this.iconSpace;
      } else {
        var width = newIcon.width + 2 * this.iconSpace;

        if (width > this.toolbarWidth) {
          this.toolbarWidth = width;
        }

        this.toolbarHeight = this.toolbarHeight + newIcon.height + this.iconSpace;
      }
    }
  }, {
    key: "updateToolbarSize",
    value: function updateToolbarSize() {
      this.backgroundRect.attr({
        height: this.toolbarHeight,
        width: this.toolbarWidth
      });
    }
  }, {
    key: "addIcon",
    value: function addIcon(newIcon) {
      this.icons.push(newIcon);
      this.iconsLayer.add(newIcon.node);
      newIcon.move(this.iconSpace, this.toolbarHeight + this.iconSpace);
      this.recalculateToolbarSize(newIcon);
      this.updateToolbarSize();
    }
  }, {
    key: "findIconByKeycode",
    value: function findIconByKeycode(keycode) {
      return this.icons.find(function (icon) {
        return icon.description !== null && icon.description.keycode === keycode;
      });
    }
  }, {
    key: "findIconByAction",
    value: function findIconByAction(action) {
      return this.icons.find(function (icon) {
        return icon.description !== null && icon.description.action === action;
      });
    }
  }, {
    key: "subscribeToKeyboardEvents",
    value: function subscribeToKeyboardEvents() {
      var _this2 = this;

      window.addEventListener("keyup", function (e) {
        if (!(e.target instanceof HTMLInputElement) && !(e.target instanceof HTMLTextAreaElement) && !(e.target instanceof HTMLSelectElement)) {
          if (_this2.areHotKeysEnabled && !e.ctrlKey && !e.altKey) {
            var icon = _this2.findIconByKeycode(e.code);

            if (icon !== undefined) {
              if (icon instanceof ToolbarSelectIcon_1.ToolbarSelectIcon || icon instanceof ToolbarSwitchIcon_1.ToolbarSwitchIcon || icon instanceof ToolbarTriggerIcon_1.ToolbarTriggerIcon) {
                icon.activate();
              }
            }
          }
        }
      });
    }
  }]);

  return Toolbar;
}();

exports.Toolbar = Toolbar;